/**
 * Active-order tracker — persists the customer's most recent order per-restaurant
 * in localStorage so that navigating back to the menu, refreshing the page, or
 * closing/reopening the tab does not make the order appear to disappear.
 *
 * No customer accounts, no history — we only keep the one currently-active order
 * per restaurant slug. Terminal statuses (COMPLETED / CANCELLED) auto-clear.
 */

const FINAL_STATUSES = new Set(["COMPLETED", "CANCELLED"]);

const keyFor = (slug) => `khudhha_active_order_${slug}`;

export function saveActiveOrder(slug, order) {
  if (!slug || !order?.id) return;
  try {
    localStorage.setItem(keyFor(slug), JSON.stringify({ id: order.id, order_number: order.order_number }));
  } catch { /* storage disabled — silently fall back to no persistence */ }
}

export function readActiveOrder(slug) {
  if (!slug) return null;
  try {
    const raw = localStorage.getItem(keyFor(slug));
    return raw ? JSON.parse(raw) : null;
  } catch {
    // Corrupt JSON — drop the bad key so we don't get stuck reading it forever.
    clearActiveOrder(slug);
    return null;
  }
}

export function clearActiveOrder(slug) {
  if (!slug) return;
  try { localStorage.removeItem(keyFor(slug)); } catch { /* noop */ }
}

export function isFinalStatus(status) {
  return FINAL_STATUSES.has(status);
}
